import 'regenerator-runtime/runtime';
import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { createBrowserHistory } from 'history';
import configureStore from './configureCartStore';
import createSagaMiddleware from 'redux-saga';
import sagas from './cartSagas';
import { routerMiddleware } from 'react-router-redux';
import { sagaActions } from './cartConsts';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n/client-i18n';
import storeSdk from 'wix-art-store-3rd-party/dist/src/sdk';
import { isDemoLocal, MockCartItems } from '../common/utils';
import biLogger from '../biLogger/biLogger';
import { ConnectedRouter } from 'connected-react-router';
import CartApp from './components/CartApp';

const initialI18n = window.__INITIAL_I18N__;
const initialState = window.__INITIAL_STATE__;
const basename = window.__BASENAME__;
const userId = window.__USER_ID__;
const biToken = window.__BI_TOKEN__;
const rootElement = document.getElementById('root');
const sagaMiddleware = createSagaMiddleware();
const history = createBrowserHistory({ basename });
const routerHistoryMiddleware = routerMiddleware(history);
const consentPolicy = initialState.consentPolicy;

biLogger.init({ instance_id: window.__INSTANCE__, galleryId: window.__GALLERYID__, visitor_id: userId, consentPolicy, biToken, location: history.location });

const store = configureStore(true, initialState, [sagaMiddleware, routerHistoryMiddleware], history);
window.store = store;

// then run the saga
sagaMiddleware.run(sagas);
render(
  <I18nextProvider i18n={i18n(initialI18n)}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <CartApp/>
      </ConnectedRouter>
    </Provider>
  </I18nextProvider>,
  rootElement
);

const dispatchItems = items => {
  store.dispatch({
    type: sagaActions.setCartItems,
    payload: items
  });
};

if (isDemoLocal()) {
  dispatchItems(MockCartItems);
}

storeSdk.cart.onRefreshCart(items => {
  dispatchItems(
    items.map(item => {
      return Object.assign({}, item.metadata, { uuid: item.uuid, status: item.status });
    })
  );
});
storeSdk.cart.onCheckout(() => {
  const payload = {};
  if (initialState) {
    const { srcId, appDefId } = initialState;
    srcId && (payload.srcId = srcId);
    appDefId && (payload.appDefId = appDefId);
  }
  store.dispatch({
    type: sagaActions.goToCheckout,
    payload
  });
});
